//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import {
  mdiMinus,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiClose,
  mdiAttachment,
  mdiChevronDown,
  mdiDotsVertical,
  mdiTrashCanOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  props: {
    isDialogFullscreen: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    // Compose Data
    const composeData = ref({})

    // Conditional Field Rendering
    const shallShowCCFIeld = ref(false)
    const shallShowBCCFIeld = ref(false)

    // Email To Option
    const emailToOptions = [
      { avatar: require('@/assets/images/avatars/1.png'), name: 'Jane Foster', email: 'amiibi@he.zw' },
      { avatar: require('@/assets/images/avatars/3.png'), name: 'Donna Frank', email: 'ocuejesov@riwwapop.ye' },
      { avatar: require('@/assets/images/avatars/5.png'), name: 'Gabrielle Robertson', email: 'luutam@ho.gi' },
      { avatar: require('@/assets/images/avatars/7.png'), name: 'Lori Spears', email: 'zicsanroc@erher.mc' },
      { avatar: require('@/assets/images/avatars/2.png'), name: 'Sandy Vega', email: 'ibuam@cimenuze.to' },
      { avatar: require('@/assets/images/avatars/4.png'), name: 'Cheryl May', email: 'kivcuci@kagwabum.tr' },
    ]
    const filterEmailToOptions = (item, queryText) => {
      const q = queryText.toLowerCase()

      return item.email.toLowerCase().includes(q) || item.name.toLowerCase().includes(q)
    }

    // Compose Actions
    const discardEmail = () => {
      emit('close-dialog')

      // Discard the previous actions
      shallShowCCFIeld.value = false
      shallShowBCCFIeld.value = false
      emit('update:isDialogFullscreen', false)

      // Reset Data
      composeData.value = {}
    }

    const sendMail = () => {
      emit('close-dialog')

      // Discard the previous actions
      shallShowCCFIeld.value = false
      shallShowBCCFIeld.value = false
      emit('update:isDialogFullscreen', false)

      // Reset data
      composeData.value = {}

      // ? Send your mail
    }

    return {
      // Compose Data
      composeData,

      // Conditional Field Rendering
      shallShowCCFIeld,
      shallShowBCCFIeld,

      // Email To Options
      emailToOptions,
      filterEmailToOptions,

      // Compose Actions
      discardEmail,
      sendMail,

      // Icons
      icons: {
        mdiMinus,
        mdiFullscreen,
        mdiFullscreenExit,
        mdiClose,
        mdiAttachment,
        mdiChevronDown,
        mdiDotsVertical,
        mdiTrashCanOutline,
      },
    }
  },
}
